/* Lumbre FX: compra directa al pago y pequeñas animaciones de conversión. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var BUY_LABEL = 'Comprar ahora';

  function setLabel(btn, text) {
    var span = btn.querySelector('span');
    if (span) { span.textContent = text; return; }
    for (var i = btn.childNodes.length - 1; i >= 0; i--) {
      var n = btn.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = text; return; }
    }
  }

  // 1 clic al pago: los botones principales añaden y llevan directo a la pantalla de pago.
  function buyNow(root) {
    (root || document).querySelectorAll('[data-lb-product] form[action*="/cart/add"], .lb-cta form[action*="/cart/add"]').forEach(function (f) {
      if (f.dataset.lbfx || f.closest('.lb-up')) return;
      f.dataset.lbfx = '1';
      var r = document.createElement('input');
      r.type = 'hidden'; r.name = 'return_to'; r.value = '/checkout';
      f.appendChild(r);
      var btn = f.querySelector('button[type="submit"]');
      if (!btn) return;
      if (btn.dataset.add) btn.dataset.add = BUY_LABEL;
      if (!btn.disabled) setLabel(btn, BUY_LABEL);
      if (f.closest('[data-lb-product]') && !f.parentElement.querySelector('.lbfx-assure')) {
        var a = document.createElement('div');
        a.className = 'lbfx-assure';
        a.innerHTML = '<span>Pago seguro</span><span>Envío gratis</span><span>14 días de devolución</span>';
        f.appendChild(a);
      }
    });
    document.querySelectorAll('.lb-sticky .lb-btn--primary').forEach(function (b) { setLabel(b, BUY_LABEL); });
  }

  // El precio da un pequeño salto al cambiar de formato.
  function pricePop() {
    if (reduce) return;
    document.querySelectorAll('[data-lb-price]').forEach(function (el) {
      if (el.dataset.lbfx) return; el.dataset.lbfx = '1';
      var last = el.textContent;
      new MutationObserver(function () {
        if (el.textContent === last) return; last = el.textContent;
        el.classList.remove('lbfx-pop'); void el.offsetWidth; el.classList.add('lbfx-pop');
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  // Chispas al pulsar un botón principal.
  function sparks() {
    if (reduce) return;
    document.addEventListener('pointerdown', function (e) {
      var b = e.target.closest && e.target.closest('.lb-btn--primary');
      if (!b || b.disabled) return;
      for (var i = 0; i < 12; i++) {
        var s = document.createElement('span');
        var ang = Math.random() * Math.PI * 2, dist = 30 + Math.random() * 45;
        s.className = 'lbfx-spark';
        s.style.left = e.clientX + 'px'; s.style.top = e.clientY + 'px';
        s.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
        s.style.setProperty('--dy', (Math.sin(ang) * dist - 20) + 'px');
        document.body.appendChild(s);
        setTimeout(function (x) { return function () { x.remove(); }; }(s), 800);
      }
    }, { passive: true });
  }

  function init(root) { buyNow(root); pricePop(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); sparks(); });
  else { init(); sparks(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
